/** Locale formatting without a lossy Number conversion. */
export function decimal(value: string | null | undefined, suffix = ''): string {
  if (value == null) return '—';
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(value);
  if (!match) return value;
  return `${match[1]}${match[2].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')}${match[3] ? `,${match[3]}` : ''}${suffix}`;
}
export function projectDate(value: string | null | undefined, timezone: string): string {
  if (!value) return '—';
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value.split('-').reverse().join('.');
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat('ru-RU', {
    timeZone: timezone,
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
}
export function projectMonth(value: string, timezone: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value.slice(0, 7);
  const instant = new Date(value);
  if (Number.isNaN(instant.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
  }).formatToParts(instant);
  return `${parts.find((part) => part.type === 'year')?.value}-${parts.find((part) => part.type === 'month')?.value}`;
}
export const statusLabel: Record<string, string> = {
  draft: 'Проект',
  uploaded: 'Загружен',
  parsing: 'Разбор',
  needs_review: 'Требует проверки',
  approved_baseline_missing: 'Нет утверждённого базового графика',
  approved_weights_missing: 'Не утверждены веса работ для расчёта общего прогресса',
  weights_not_normalized: 'Веса работ не приведены к общей сумме',
  reporting_gap: 'Не хватает подтверждённых данных о выполнении',
  assumed_supply: 'Наличие материалов принято как допущение',
  monthly_plan_missing: 'Нет выпущенного месячного задания',
  period_not_released: 'Месячное задание ещё не выпущено',
  constraint_violation: 'Прогноз нарушает договорные или директивные сроки работ',
  negative_float: 'Отрицательный резерв: прогноз позже договорных сроков',
  expected_rd_catalogue_unknown: 'Не задан перечень ожидаемой РД — полнота РД не оценена',
  partial_rd_catalogue: 'Перечень РД неполный',
  rd_catalogue_needs_review: 'Перечень РД требует проверки',
  unmapped_accepted_fact: 'Есть принятый факт без привязки к работам графика',
  started_remaining_unknown: 'Не задан остаток длительности начатых работ',
  rejected: 'Отклонено',
  accepted: 'Принято',
  returned: 'Возвращено',
  pending: 'Ожидает приёмки',
  approved: 'Утверждён',
  approved_customer: 'Согласован Заказчиком',
  approved_internal: 'Утверждён внутри организации',
  internal_review: 'На внутреннем согласовании',
  detailed_baseline: 'Детальный baseline',
  complete_rd: 'Полная подтверждённая РД',
  confirmed: 'Подтверждено',
  rd: 'Рабочая документация',
  supply: 'Поставки',
  actual: 'Выполнение',
  id: 'Устойчивый ID',
  name: 'Наименование',
  quantity: 'Количество',
  unit: 'Единица',
  duration_minutes: 'Длительность, минуты',
  calendar_id: 'Календарь',
  wbs_id: 'Раздел WBS',
  activity_id: 'Работа',
  performed_date: 'Дата выполнения',
  labour_weight: 'Подтверждённый вес',
  record_uid: 'Код позиции источника',
  source_ref: 'Источник',
  submitted: 'На согласовании',
  duplicate_review: 'Изменение источника — требуется проверка',
  released: 'Выпущен',
  signed: 'Подписан',
  dispatched: 'Направлен',
  queued: 'В очереди',
  running: 'Расчёт выполняется',
  processing: 'Обработка выполняется',
  completed: 'Обработка завершена',
  applied: 'Применён в график',
  succeeded: 'Рассчитан',
  failed: 'Ошибка',
  cancelled: 'Отменён',
  open: 'Открыто',
  closed_by_letter: 'Закрыто по письму',
  unknown: 'Неизвестно',
  partial_rd: 'По подтверждённой части РД',
  full_rd: 'Полная РД',
  confirmed_rd_subset: 'По подтверждённой части РД',
  sent: 'Передано провайдеру',
  delivered: 'Доставлено',
  uncertain: 'Отправка не подтверждена',
  retry: 'Повтор доставки',
  dead: 'Доставка остановлена с ошибкой',
  assumed_available: 'Допущение наличия',
  contract: 'Договорной',
  current: 'Текущий',
  forecast: 'Прогноз',
  scenario: 'Сценарий',
  achieved: 'Достигнута',
  not_achieved: 'Не достигнута',
  verified: 'Подтверждено',
  no_plan: 'Нет плана',
  zero_denominator: 'Нулевой знаменатель',
  approved_quantity_unknown: 'Нет утверждённого объёма для сравнения',
  denominator_unit_unknown: 'Единица утверждённого объёма не подтверждена',
  actual_unit_unknown: 'Единица принятого факта не подтверждена',
  unit_mismatch: 'Единицы объёма и принятого факта различаются',
  unit_mismatch_or_unknown: 'Единицы факта не подтверждены или отличаются',
  unschedulable: 'Нет допустимого размещения',
  physical_progress: 'Физическое выполнение',
  approved_labour_weights: 'Подтверждённые трудозатраты',
  manual_weights: 'Утверждённые веса',
  full_project: 'Весь проект',
  partial: 'Частичный охват',
  complete: 'Полный охват',
  ok: 'Доступен',
  unavailable: 'Недоступен',
  stale: 'Данные устарели',
  person: 'Персонал',
  equipment: 'Техника',
  team: 'Бригада',
  field: 'Прораб',
  pto: 'ПТО',
  manual: 'Ручной ввод ПТО',
  deviation_act: 'Акт фиксации отклонений',
  recovery_plan: 'План ликвидации отставания',
  letter: 'Письмо по вехе',
  period_plan: 'Месячно-суточное задание',
  planfact: 'План-факт',
  schedule: 'График',
  rd_readiness_applied: 'Начало работ перенесено по готовности РД',
  rd_readiness_conditional: 'Прогноз условный: даты РД не подтверждены, взята плановая выдача',
  downstream_rd_readiness_conditional: 'Прогноз зависящих работ условный по датам РД',
  rd_readiness_unknown: 'Готовность РД не определена — сроки работ не рассчитаны',
  downstream_rd_readiness_unknown: 'Сроки зависящих работ не рассчитаны: готовность РД не определена',
};
export const label = (value: string) => statusLabel[value] ?? value;
